export default __webpack_public_path__ + "static/media/evenfi_personalloans_2.bd9fa2be.png";